import { isContainerLarge } from './renderer/renderer.helpers';

/**
 * True, if current white CONTAINER_LARGE_* comes after brand/grey CONTAINER_LARGE_*
 *
 * @param {ApiElement} currElem
 * @param {ApiElement} nextElem
 * @returns {boolean}
 */
export default (currElem, nextElem) => {
  return (
    isContainerLarge(currElem) &&
    isContainerLarge(nextElem) &&
    (currElem.style === 'BRAND' || currElem.style === 'GRAY') &&
    nextElem.style === 'NONE'
  );
};
